import React from "react";
import PropTypes from "prop-types";
import { Card, Col, Row } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
/*
  {
    name: "Ago",
    Label1: 2400,
    Label2: 1600,
    Label3: 2800,
  },
  {
    name: "Sep",
    Label1: 2900,
    Label2: 3400,
    Label3: 2200,
  },
  {
    name: "Oct",
    Label1: 1500,
    Label2: 1400,
    Label3: 3000,
  },
  {
    name: "Nov",
    Label1: 3100,
    Label2: 3500,
    Label3: 2600,
  },
];
*/
const CardRendimientoPRC = ({ data }) => {
  
const normalizar = (monto, referencia) =>  parseFloat(referencia) > 0 ? (parseFloat(monto) * 100) / parseFloat(referencia) : 0.0;

  const normalizarDatos = (data) => {
    if (!data) return [];
    return [
      {
        name: "Ingresos",
        credito: normalizar(data.monto_credito, data.monto_total),
        debito: normalizar(data.monto_debito, data.monto_total),
        efectivo: normalizar(data.monto_efectivo, data.monto_total),
        pagos_tic : normalizar(data.monto_pagos_tic, data.monto_total),
        transferencia: normalizar(data.monto_transferencia, data.monto_total),
      },
    ];
  };

  return (
    <Card className="h-100">
      <Card.Header>
        <Row className="w-100 d-flex justify-content-between align-items-center mb-3">
          <Col sm="10">
            <h4
              className="fw-normal"
              style={{
                fontSize: "1.2rem",
                letterSpacing: "1px",
                color: "black",
              }}
            >
              Ingresos
            </h4>
          </Col>
        </Row>
      </Card.Header>

      <Card.Body style={{ height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          { data && <BarChart data={normalizarDatos(data)}>
            <CartesianGrid strokeDasharray="4 1" vertical={false} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend
              verticalAlign="top"
              height={36}
              iconType="circle"
              iconSize={10}
            />
            <Bar dataKey="credito" fill="#4f46e5" radius={[4, 4, 0, 0]} />
            <Bar dataKey="debito" fill="#ec4899" radius={[4, 4, 0, 0]} />
            <Bar dataKey="efectivo" fill="#14b8a6" radius={[4, 4, 0, 0]} />
            <Bar dataKey="pagos_tic" fill="#4f46e5" radius={[4,4,0,0]} />
            <Bar dataKey="transferencia" fill="#f59e0b" radius={[4, 4, 0, 0]} />
          </BarChart>}

        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

CardRendimientoPRC.propTypes = {
  data: PropTypes.shape({
    monto_efectivo: PropTypes.number,
    monto_transferencia: PropTypes.number,
    monto_debito: PropTypes.number,
    monto_credito: PropTypes.number,
    monto_pagos_tic: PropTypes.number,
    monto_total: PropTypes.number,
  }).isRequired,
};

export default CardRendimientoPRC;


